import { httpRequest } from "@/axios/axios-api";
import moment from "moment";

export default {
  data() {
    return {
      mockExamLibList: [] // 模拟考试题库列表
    };
  },
  created: function() {
    // 先加载考试信息，判断模拟考试是否开放了
    this.loadExamInfo();
  },
  methods: {
    async loadExamInfo() {
      const loadingInstance = this.$loading({ text: "加载中" });
      let res = await httpRequest("/app/practice-test", "get", null);
      if (res !== null && res !== undefined && res.code === 200) {
        // 判断是否已经开启了模拟考试
        if (
          res.data.testStartTime !== undefined &&
          res.data.testStartTime !== null &&
          res.data.testEndTime !== undefined &&
          res.data.testEndTime !== null
        ) {
          const testStartTime = new Date(res.data.testStartTime);
          const testEndTime = new Date(res.data.testEndTime);
          // 计算距离模拟考试还有多久
          const now = new Date();
          let examLeftDays = Math.ceil(
            (testStartTime - now) / (1000 * 3600 * 24)
          );
          if (examLeftDays < 0) {
            // 已经开始考试了，判断是否已经结束了
            const examEndLeftDays = Math.ceil(
              (testEndTime - now) / (1000 * 3600 * 24)
            );
            if (examEndLeftDays < 0) {
              examLeftDays = -1; // 表示已经结束了
            } else {
              examLeftDays = 0; // 表示进行中
            }
          }
          if (examLeftDays > 0) {
            this.$alert(
              "模拟考试还未开放<br />开放时间：" +
                moment(testStartTime).format("YYYY-MM-DD") +
                "~" +
                moment(testEndTime).format("YYYY-MM-DD"),
              "提示",
              { dangerouslyUseHTMLString: true }
            );
          } else if (examLeftDays < 0) {
            this.$alert(
              "模拟考试已结束<br />开放时间：" +
                moment(testStartTime).format("YYYY-MM-DD") +
                "~" +
                moment(testEndTime).format("YYYY-MM-DD"),
              "提示",
              { dangerouslyUseHTMLString: true }
            );
          } else {
            this.mockExamLibList = res.data.list;
          }
        } else {
          this.$message.error("请先报名");
          this.$router.push({ path: "/" });
        }
      } else {
        this.$message.error("参数异常");
      }
      loadingInstance.close();
    },
    go2MockExamPage(libIdx) {
      this.$router.push({
        path: "/mockExam",
        query: { ptId: this.mockExamLibList[libIdx].ptId }
      });
    }
  }
};
